module.exports = "https://static.wanderu.com/ui-react/_next/static/media/flight-grey.3dde7ad7.svg";